import * as React from 'react';
/**
 *
 * Original name: zip
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=11091%3A7
 *
 */
export const ZipPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M56 8H8v41.513A6.487 6.487 0 0 0 14.487 56h35.026A6.487 6.487 0 0 0 56 49.513V8ZM12 49.513V12h14.017v3.984h6v4h-6v4h6v4h-6v4H26v6.18h.001c.053 4.023 1.91 5.82 5.999 5.82 4.09 0 5.946-1.797 5.999-5.82H38v-6.18h-5.983v-4h6v-4h-6v-4h6v-4h-6V12H52v37.513A2.487 2.487 0 0 1 49.513 52H14.487A2.487 2.487 0 0 1 12 49.513Zm20-9.529a2 2 0 1 0 0-3.999 2 2 0 0 0 0 4Z", fill: "currentColor" })));
